// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";import {
//   IoPencil,
//   IoTrashBin,
//   IoThumbsUp,
//   IoThumbsDown,
//   IoChevronDown,
//   IoChevronUp,
// } from "react-icons/io5";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { jwtDecode } from "jwt-decode";

// const ClarificationBoard = ({ user, requestId }) => {
//   /* ─── STATE ─────────────────────────────────────────── */
//   const [comments, setComments] = useState([]);
//   const [newComment, setNewComment] = useState("");

//   // comment editing
//   const [editingId, setEditingId] = useState(null);
//   const [editingText, setEditingText] = useState("");

//   // reply editing
//   const [editingReplyId, setEditingReplyId] = useState(null);
//   const [editingReplyText, setEditingReplyText] = useState("");

//   // delete comment / reply
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [deleteReplyId, setDeleteReplyId] = useState(null);
//   const [isSending, setIsSending] = useState(false);

//   // per-comment reply draft
//   const [replyDrafts, setReplyDrafts] = useState({});

//   const [submittingIds, setSubmittingIds] = useState({});
//   /* ─── CONFIG ────────────────────────────────────────── */
//   const API_V2 = process.env.REACT_APP_SERVER_URL_V2;
//   const API_V1 = API_V2.replace("/api/v2", "/api/v1");
//   const accessToken = localStorage.getItem("accessToken");
//   let loggedSupplierId = null;

//   if (accessToken) {
//     try {
//       const payload = jwtDecode(accessToken); // ← decode once
//       console.log("Playload---->>>>>", payload);
//       loggedSupplierId =
//         payload.supplier_id ||
//         payload.id || // fallback
//         payload.userId ||
//         null; // fallback
//     } catch (e) {
//       console.error("JWT decode error:", e);
//     }
//   }

//   console.log("👉 loggedSupplierId =", loggedSupplierId); // e.g. 85
//   /* helper: build profile-photo URL */
//   const buildProfileUrl = (userId, profileId) =>
//     userId && profileId
//       ? `${API_V1}/photos/${userId}/images/${profileId}`
//       : null;

//   /* sort newest → oldest */
//   const sortNewestFirst = (a, b) =>
//     new Date(b.created_at || b.createdAt) -
//     new Date(a.created_at || a.createdAt);

//   /* ─── FETCH COMMENTS + REPLIES ──────────────────────── */
//   const fetchComments = useCallback(async () => {
//     if (!requestId) return;
//     try {
//       /* 1️⃣ parent comments */
//       const { data } = await axios.get(
//         `${API_V2}/quotes/getallcomment/${requestId}`,
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       const top = (Array.isArray(data.data) ? data.data : [data.data || []])
//         .filter(Boolean)
//         .sort(sortNewestFirst);

//       /* 2️⃣ replies */
//       const withReplies = await Promise.all(
//         top.map(async (comment) => {
//           try {
//             const res = await axios.get(
//               `${API_V1}/quotes/allcommentreply/${comment.id}`,
//               { headers: { Authorization: `Bearer ${accessToken}` } }
//             );
//             const replies = (
//               Array.isArray(res.data.data)
//                 ? res.data.data
//                 : [res.data.data || []]
//             )
//               .filter(Boolean)
//               .sort(sortNewestFirst);
//             return { ...comment, replies };
//           } catch {
//             /* fallback to V2 or empty */
//             try {
//               const resV2 = await axios.get(
//                 `${API_V2}/quotes/getreplycomment/${comment.id}`,
//                 { headers: { Authorization: `Bearer ${accessToken}` } }
//               );
//               const repliesV2 = (
//                 Array.isArray(resV2.data.data)
//                   ? resV2.data.data
//                   : [resV2.data.data || []]
//               )
//                 .filter(Boolean)
//                 .sort(sortNewestFirst);
//               return { ...comment, replies: repliesV2 };
//             } catch {
//               return { ...comment, replies: [] };
//             }
//           }
//         })
//       );

//       setComments(withReplies);
//     } catch {
//       /* toast.error("Failed to load comments."); */
//     }
//   }, [API_V1, API_V2, accessToken, requestId]);

//   useEffect(() => {
//     fetchComments();
//   }, [fetchComments]);

//   /* ─── ADD COMMENT ───────────────────────────────────── */
//   const handleAddComment = async () => {
//     if (!newComment.trim()) return;
//     try {
//       await axios.post(
//         `${API_V2}/quotes/comment/${requestId}`,
//         { comment: newComment.trim() },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       setNewComment("");
//       toast.success("Comment added.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to add comment.");
//     }
//   };

//   /* ─── EDIT COMMENT ──────────────────────────────────── */
//   const openEdit = (id, text) => {
//     setEditingId(id);
//     setEditingText(text);
//   };
//   const saveEdit = async () => {
//     if (!editingText.trim()) return;
//     try {
//       await axios.put(
//         `${API_V2}/quotes/editcomment/${editingId}`,
//         { comment: editingText.trim() },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       setEditingId(null);
//       setEditingText("");
//       toast.success("Comment updated.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to update comment.");
//     }
//   };

//   /* ─── EDIT REPLY ────────────────────────────────────── */
//   const openEditReply = (id, text) => {
//     setEditingReplyId(id);
//     setEditingReplyText(text);
//   };
//   const saveEditReply = async () => {
//     if (!editingReplyText.trim()) return;
//     try {
//       await axios.put(
//         `${API_V2}/quotes/editreply/${editingReplyId}`,
//         { reply: editingReplyText.trim() },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       setEditingReplyId(null);
//       setEditingReplyText("");
//       toast.success("Reply updated.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to update reply.");
//     }
//   };

//   /* ─── DELETE COMMENT ────────────────────────────────── */
//   const confirmDelete = async () => {
//     try {
//       await axios.delete(`${API_V2}/quotes/deletecomment/${deleteTarget}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       setDeleteTarget(null);
//       toast.success("Comment deleted.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to delete comment.");
//     }
//   };

//   /* ─── DELETE REPLY ──────────────────────────────────── */
//   const confirmDeleteReply = async () => {
//     try {
//       await axios.delete(`${API_V2}/quotes/delete/${deleteReplyId}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       setDeleteReplyId(null);
//       toast.success("Reply deleted.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to delete reply.");
//     }
//   };

//   /* ─── LIKE / DISLIKE ───────────────────────────────── */
//   const handleReaction = async (commentId, type) => {
//     try {
//       await axios.post(
//         `${API_V2}/quotes/likedislike/${commentId}?reaction_type=${type}`,
//         null,
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       toast.success("Reaction updated.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to react.");
//     }
//   };

//   /* ─── ADD REPLY ─────────────────────────────────────── */
//   // const handleAddReply = async (commentId) => {
//   //   const text = (replyDrafts[commentId] || "").trim();
//   //   if (!text) return;
//   //   try {
//   //     await axios.post(
//   //       `${API_V2}/quotes/reply/${commentId}`,
//   //       { reply: text },
//   //       { headers: { Authorization: `Bearer ${accessToken}` } }
//   //     );
//   //     setReplyDrafts((p) => ({ ...p, [commentId]: "" }));
//   //     toast.success("Reply added.");
//   //     fetchComments();
//   //   } catch {
//   //     toast.error("Failed to add reply.");
//   //   }
//   // };

//   const handleAddReply = async (commentId) => {
//     const text = (replyDrafts[commentId] || "").trim();
//     if (!text || submittingIds[commentId]) return;

//     setSubmittingIds((prev) => ({ ...prev, [commentId]: true }));

//     try {
//       await axios.post(
//         `${API_V2}/quotes/reply/${commentId}`,
//         { reply: text },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       setReplyDrafts((p) => ({ ...p, [commentId]: "" }));
//       toast.success("Reply added.");
//       fetchComments();
//     } catch {
//       toast.error("Failed to add reply.");
//     } finally {
//       setSubmittingIds((prev) => {
//         const updated = { ...prev };
//         delete updated[commentId];
//         return updated;
//       });
//     }
//   };

//   /* ─── RENDER ────────────────────────────────────────── */
//   return (
//     <div className="mt-5 border flex flex-col bg-gray-50 rounded-lg shadow-lg max-h-[600px]">
//       {/* Header */}
//       {/* ───────── Header (responsive) ───────── */}
//       <div className="flex-shrink-0 bg-white px-3 sm:px-6 py-3 sm:py-4 border-b">
//         <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
//           <h3 className="text-base sm:text-xl font-semibold text-gray-800">
//             Clarification Board
//           </h3>

//           {/* Notice text */}
//           <h2 className="text-xs sm:text-sm text-gray-600 text-left sm:text-right">
//             No Spam, self-promotion or advertisement is permitted.
//           </h2>
//         </div>
//       </div>

//       {/* New comment */}

//       {/* <div className="flex-shrink-0 bg-gray-100 p-4 border-t">
//         <div className="flex items-center space-x-3">
//           <input
//             className="flex-1 bg-white border rounded-full px-4 py-2 focus:ring-2 focus:ring-blue-500"
//             placeholder="Type a message..."
//             value={newComment}
//             onChange={(e) => setNewComment(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && handleAddComment()}
//           />
//           <button
//             className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-700"
//             onClick={handleAddComment}
//           >
//             Send
//           </button>
//         </div>

//       </div> */}

//       {/* ───────── New-comment bar (responsive) ───────── */}
//       <div className="flex-shrink-0 bg-gray-100 px-3 sm:px-4 py-3 sm:py-4 border-t">
//         <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
//           <input
//             className="flex-1 bg-white border rounded-full px-3 sm:px-4 py-2 text-sm sm:text-base
//                  focus:ring-2 focus:ring-blue-500"
//             placeholder="Type a message..."
//             value={newComment}
//             onChange={(e) => setNewComment(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && handleAddComment()}
//           />

//           {/* Full-width on mobile, auto on ≥640 px */}
//           <button
//             className="w-full sm:w-auto bg-blue-600 text-white text-sm sm:text-base
//                  px-4 sm:px-5 py-2 rounded-full hover:bg-blue-700"
//             onClick={async () => {
//               if (isSending) return; // block duplicate click
//               setIsSending(true);
//               await handleAddComment();
//               setIsSending(false);
//             }}
//             disabled={isSending}
//           >
//             {isSending ? "Sending..." : "Send"}{" "}
//           </button>
//         </div>
//       </div>

//       {/* Comment list */}
//       {/* ───────── Comment list (responsive) ───────── */}
//       <div className="flex-1 overflow-y-auto px-3 sm:px-4 py-3 sm:py-4 space-y-3 sm:space-y-4 bg-white">
//         {comments.length === 0 ? (
//           <p className="text-center text-gray-500 italic">No comments yet.</p>
//         ) : (
//           comments.map((c) => {
//             const isSupplierComment = !!c.supplier_id;
//             const displayName = isSupplierComment
//               ? "Anonymous"
//               : `${c.User?.first_name || ""} ${
//                   c.User?.last_name || ""
//                 }`.trim() || "Customer";

//             return (
//               <div key={c.id} className="flex items-start gap-2 sm:gap-3">
//                 {/* Avatar / initial */}
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-400 text-white flex items-center justify-center font-medium flex-shrink-0">
//                   {displayName?.[0]?.toUpperCase() || "A"}
//                 </div>

//                 {/* Bubble + replies */}
//                 <div className="flex-1">
//                   {/* ─── Bubble ─── */}
//                   <div className="bg-gray-100 rounded-xl px-3 sm:px-4 py-2">
//                     {/* header (name ↔ icons) */}
//                     <div className="flex items-center justify-between">
//                       <span className="font-medium text-gray-800 text-sm sm:text-base">
//                         {displayName}
//                       </span>

//                       {Number(c.User?.id) === Number(loggedSupplierId) && (
//                         <div className="flex gap-2 text-gray-400">
//                           <IoPencil
//                             className="w-4 h-4 cursor-pointer hover:text-blue-600"
//                             onClick={() => openEdit(c.id, c.comment)}
//                           />
//                           <IoTrashBin
//                             className="w-4 h-4 cursor-pointer hover:text-red-600"
//                             onClick={() => setDeleteTarget(c.id)}
//                           />
//                         </div>
//                       )}
//                     </div>

//                     {/* body / edit mode */}
//                     {editingId === c.id ? (
//                       <div className="mt-1 flex flex-col sm:flex-row sm:gap-2 gap-2">
//                         <input
//                           className="flex-1 border rounded-md px-2 py-1 text-sm focus:ring-2 focus:ring-green-500"
//                           value={editingText}
//                           onChange={(e) => setEditingText(e.target.value)}
//                         />
//                         <div className="flex gap-2 self-end sm:self-auto">
//                           <button
//                             className="text-green-600 font-medium text-sm"
//                             onClick={saveEdit}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="text-gray-600 text-sm"
//                             onClick={() => setEditingId(null)}
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       </div>
//                     ) : (
//                       <p className="mt-1 text-gray-700 text-sm sm:text-base">
//                         {c.comment}
//                       </p>
//                     )}

//                     {/* like / dislike */}
//                     <div className="mt-2 flex gap-4 text-sm text-gray-500">
//                       <button
//                         className="flex items-center gap-1"
//                         onClick={() => handleReaction(c.id, "like")}
//                       >
//                         <IoThumbsUp className="w-4 h-4" />
//                         <span>{c.like || 0}</span>
//                       </button>
//                       <button
//                         className="flex items-center gap-1"
//                         onClick={() => handleReaction(c.id, "dislike")}
//                       >
//                         <IoThumbsDown className="w-4 h-4" />
//                         <span>{c.dislike || 0}</span>
//                       </button>
//                     </div>
//                   </div>

//                   {/* ─── Replies ─── */}
//                   <div className="mt-3 pl-6 sm:pl-12 space-y-3">
//                     {c.replies.map((r) => {
//                       const ru = r.User || r.Customer || r.user || {};
//                       const isSupplierReply = r.reply_by_role === "SUPPLIER";
//                       const replyName = isSupplierReply
//                         ? "Anonymous"
//                         : `${ru.first_name || ""} ${
//                             ru.last_name || ""
//                           }`.trim() ||
//                           r.author ||
//                           "Customer";

//                       return (
//                         <div
//                           key={r.id}
//                           className="flex items-start gap-2 sm:gap-3"
//                         >
//                           <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center font-medium flex-shrink-0">
//                             {replyName?.[0]?.toUpperCase() || "C"}
//                           </div>

//                           {/* reply bubble */}
//                           <div className="flex-1 bg-gray-100 rounded-xl px-3 py-2">
//                             <div className="flex items-center justify-between">
//                               <span className="font-medium text-gray-800 text-xs sm:text-sm">
//                                 {replyName}
//                               </span>

//                               {isSupplierReply &&
//                                 Number(
//                                   r.supplier_id ??
//                                     r.reply_by_supplier_id ??
//                                     ru?.id
//                                 ) === Number(loggedSupplierId) && (
//                                   <div className="flex gap-2 text-gray-400">
//                                     <IoPencil
//                                       className="w-4 h-4 cursor-pointer hover:text-blue-600"
//                                       onClick={() =>
//                                         openEditReply(r.id, r.reply)
//                                       }
//                                     />
//                                     <IoTrashBin
//                                       className="w-4 h-4 cursor-pointer hover:text-red-600"
//                                       onClick={() => setDeleteReplyId(r.id)}
//                                     />
//                                   </div>
//                                 )}
//                             </div>

//                             {editingReplyId === r.id ? (
//                               <div className="mt-1 flex flex-col sm:flex-row sm:gap-2 gap-2">
//                                 <input
//                                   className="flex-1 border rounded-md px-2 py-1 text-xs sm:text-sm focus:ring-2 focus:ring-green-500"
//                                   value={editingReplyText}
//                                   onChange={(e) =>
//                                     setEditingReplyText(e.target.value)
//                                   }
//                                 />
//                                 <div className="flex gap-2 self-end sm:self-auto">
//                                   <button
//                                     className="text-green-600 text-xs sm:text-sm font-medium"
//                                     onClick={saveEditReply}
//                                   >
//                                     Save
//                                   </button>
//                                   <button
//                                     className="text-gray-600 text-xs sm:text-sm"
//                                     onClick={() => setEditingReplyId(null)}
//                                   >
//                                     Cancel
//                                   </button>
//                                 </div>
//                               </div>
//                             ) : (
//                               <p className="mt-1 text-gray-700 text-xs sm:text-sm">
//                                 {r.reply || r.comment}
//                               </p>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}

//                     {/* reply input */}
//                     <div className="pl-6 sm:pl-12 pt-3 flex flex-col sm:flex-row sm:gap-2 gap-2">
//                       <input
//                         className="flex-1 border rounded-md px-2 py-1 text-xs sm:text-sm focus:ring-2 focus:ring-blue-500"
//                         placeholder="Type your reply..."
//                         value={replyDrafts[c.id] || ""}
//                         onChange={(e) =>
//                           setReplyDrafts((p) => ({
//                             ...p,
//                             [c.id]: e.target.value,
//                           }))
//                         }
//                         onKeyDown={(e) => {
//                           if (e.key === "Enter" && !submittingIds[c.id]) {
//                             e.preventDefault();
//                             handleAddReply(c.id);
//                           }
//                         }}
//                       />
//                       <div className="flex gap-2 self-end sm:self-auto">
//                         <button
//                           className="bg-blue-600 text-white text-xs sm:text-sm px-3 py-1 rounded-md hover:bg-blue-700"
//                           onClick={() => handleAddReply(c.id)}
//                           disabled={!!submittingIds[c.id]}
//                         >
//                           Send
//                         </button>
//                         <button
//                           className="text-xs sm:text-sm text-gray-600"
//                           onClick={() =>
//                             setReplyDrafts((p) => ({ ...p, [c.id]: "" }))
//                           }
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             );
//           })
//         )}
//       </div>

//       {/* delete comment confirmation */}
//       {deleteTarget && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 w-80">
//             <p className="text-center mb-4">Delete this comment?</p>
//             <div className="flex justify-center space-x-4">
//               <button
//                 className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
//                 onClick={() => setDeleteTarget(null)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
//                 onClick={confirmDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* delete reply confirmation */}
//       {deleteReplyId && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 w-80">
//             <p className="text-center mb-4">Delete this reply?</p>
//             <div className="flex justify-end space-x-4">
//               <button
//                 className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
//                 onClick={() => setDeleteReplyId(null)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
//                 onClick={confirmDeleteReply}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default ClarificationBoard;

// ClarificationBoard.jsx
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  IoPencil,
  IoTrashBin,
  IoThumbsUp,
  IoThumbsDown,
  IoChevronDown,
  IoChevronUp,
} from "react-icons/io5";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
// 🔽 Adjust this path if your folder depth differs
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const ClarificationBoard = ({ user, requestId }) => {
  /* ─── STATE ─────────────────────────────────────────── */
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  // comment editing
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState("");

  // reply editing
  const [editingReplyId, setEditingReplyId] = useState(null);
  const [editingReplyText, setEditingReplyText] = useState("");

  // delete comment / reply
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteReplyId, setDeleteReplyId] = useState(null);

  const [isSending, setIsSending] = useState(false); // block double submit
  const [replyDrafts, setReplyDrafts] = useState({}); // per-comment reply draft
  const [submittingIds, setSubmittingIds] = useState({}); // per-reply submit lock

  const dispatch = useDispatch();

  /* ─── CONFIG ────────────────────────────────────────── */
  const API_V2 = process.env.REACT_APP_SERVER_URL_V2;
  const API_V1 = API_V2?.replace("/api/v2", "/api/v1");

  // Always fetch a fresh token before requests
  const ensureAuth = useCallback(async () => {
    await dispatch(refreshIfNeeded());
    const fresh = localStorage.getItem("accessToken");
    if (!fresh) throw new Error("No access token available");
    return {
      headers: {
        Authorization: `Bearer ${fresh}`,
      },
    };
  }, [dispatch]);

  // Decode current token (fresh each render) for id checks
  const getLoggedSupplierId = useCallback(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return null;
    try {
      const payload = jwtDecode(token);
      return (
        payload.supplier_id ||
        payload.id || // fallback
        payload.userId ||
        null
      );
    } catch {
      return null;
    }
  }, []);

  /* helper: build profile-photo URL */
  const buildProfileUrl = (userId, profileId) =>
    userId && profileId
      ? `${API_V1}/photos/${userId}/images/${profileId}`
      : null;

  /* sort newest → oldest */
  const sortNewestFirst = (a, b) =>
    new Date(b.created_at || b.createdAt) -
    new Date(a.created_at || a.createdAt);

  /* ─── FETCH COMMENTS + REPLIES ──────────────────────── */
  const fetchComments = useCallback(async () => {
    if (!requestId) return;
    try {
      const headers = await ensureAuth();

      // 1️⃣ parent comments
      const { data } = await axios.get(
        `${API_V2}/quotes/getallcomment/${requestId}`,
        headers
      );

      const top = (Array.isArray(data.data) ? data.data : [data.data || []])
        .filter(Boolean)
        .sort(sortNewestFirst);

      // 2️⃣ replies (try V1, then V2, else empty)
      const withReplies = await Promise.all(
        top.map(async (comment) => {
          try {
            const res = await axios.get(
              `${API_V1}/quotes/allcommentreply/${comment.id}`,
              headers
            );
            const replies = (
              Array.isArray(res.data.data)
                ? res.data.data
                : [res.data.data || []]
            )
              .filter(Boolean)
              .sort(sortNewestFirst);
            return { ...comment, replies };
          } catch {
            try {
              const resV2 = await axios.get(
                `${API_V2}/quotes/getreplycomment/${comment.id}`,
                headers
              );
              const repliesV2 = (
                Array.isArray(resV2.data.data)
                  ? resV2.data.data
                  : [resV2.data.data || []]
              )
                .filter(Boolean)
                .sort(sortNewestFirst);
              return { ...comment, replies: repliesV2 };
            } catch {
              return { ...comment, replies: [] };
            }
          }
        })
      );

      setComments(withReplies);
    } catch {
      /* optional: toast.error("Failed to load comments.") */
    }
  }, [API_V1, API_V2, ensureAuth, requestId]);

  useEffect(() => {
    fetchComments();
  }, [fetchComments]);

  /* ─── ADD COMMENT ───────────────────────────────────── */
  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${API_V2}/quotes/comment/${requestId}`,
        { comment: newComment.trim() },
        headers
      );
      setNewComment("");
      toast.success("Comment added.");
      fetchComments();
    } catch {
      toast.error("Failed to add comment.");
    }
  };

  /* ─── EDIT COMMENT ──────────────────────────────────── */
  const openEdit = (id, text) => {
    setEditingId(id);
    setEditingText(text);
  };

  const saveEdit = async () => {
    if (!editingText.trim()) return;
    try {
      const headers = await ensureAuth();
      await axios.put(
        `${API_V2}/quotes/editcomment/${editingId}`,
        { comment: editingText.trim() },
        headers
      );
      setEditingId(null);
      setEditingText("");
      toast.success("Comment updated.");
      fetchComments();
    } catch {
      toast.error("Failed to update comment.");
    }
  };

  /* ─── EDIT REPLY ────────────────────────────────────── */
  const openEditReply = (id, text) => {
    setEditingReplyId(id);
    setEditingReplyText(text);
  };

  const saveEditReply = async () => {
    if (!editingReplyText.trim()) return;
    try {
      const headers = await ensureAuth();
      await axios.put(
        `${API_V2}/quotes/editreply/${editingReplyId}`,
        { reply: editingReplyText.trim() },
        headers
      );
      setEditingReplyId(null);
      setEditingReplyText("");
      toast.success("Reply updated.");
      fetchComments();
    } catch {
      toast.error("Failed to update reply.");
    }
  };

  /* ─── DELETE COMMENT ────────────────────────────────── */
  const confirmDelete = async () => {
    try {
      const headers = await ensureAuth();
      await axios.delete(
        `${API_V2}/quotes/deletecomment/${deleteTarget}`,
        headers
      );
      setDeleteTarget(null);
      toast.success("Comment deleted.");
      fetchComments();
    } catch {
      toast.error("Failed to delete comment.");
    }
  };

  /* ─── DELETE REPLY ──────────────────────────────────── */
  const confirmDeleteReply = async () => {
    try {
      const headers = await ensureAuth();
      await axios.delete(`${API_V2}/quotes/delete/${deleteReplyId}`, headers);
      setDeleteReplyId(null);
      toast.success("Reply deleted.");
      fetchComments();
    } catch {
      toast.error("Failed to delete reply.");
    }
  };

  /* ─── LIKE / DISLIKE ───────────────────────────────── */
  const handleReaction = async (commentId, type) => {
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${API_V2}/quotes/likedislike/${commentId}?reaction_type=${type}`,
        null,
        headers
      );
      toast.success("Reaction updated.");
      fetchComments();
    } catch {
      toast.error("Failed to react.");
    }
  };

  /* ─── ADD REPLY ─────────────────────────────────────── */
  const handleAddReply = async (commentId) => {
    const text = (replyDrafts[commentId] || "").trim();
    if (!text || submittingIds[commentId]) return;

    setSubmittingIds((prev) => ({ ...prev, [commentId]: true }));
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${API_V2}/quotes/reply/${commentId}`,
        { reply: text },
        headers
      );
      setReplyDrafts((p) => ({ ...p, [commentId]: "" }));
      toast.success("Reply added.");
      fetchComments();
    } catch {
      toast.error("Failed to add reply.");
    } finally {
      setSubmittingIds((prev) => {
        const updated = { ...prev };
        delete updated[commentId];
        return updated;
      });
    }
  };

  /* ─── RENDER ────────────────────────────────────────── */
  const currentSupplierId = getLoggedSupplierId();

  return (
    <div className="mt-5 border flex flex-col bg-gray-50 rounded-lg shadow-lg max-h-[600px]">
      {/* Header */}
      <div className="flex-shrink-0 bg-white px-3 sm:px-6 py-3 sm:py-4 border-b">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
          <h3 className="text-base sm:text-xl font-semibold text-gray-800">
            Clarification Board
          </h3>
          <h2 className="text-xs sm:text-sm text-gray-600 text-left sm:text-right">
            No Spam, self-promotion or advertisement is permitted.
          </h2>
        </div>
      </div>

      {/* New-comment bar */}
      <div className="flex-shrink-0 bg-gray-100 px-3 sm:px-4 py-3 sm:py-4 border-t">
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
          <input
            className="flex-1 bg-white border rounded-full px-3 sm:px-4 py-2 text-sm sm:text-base focus:ring-2 focus:ring-blue-500"
            placeholder="Type a message..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAddComment()}
          />
          <button
            className="w-full sm:w-auto bg-blue-600 text-white text-sm sm:text-base px-4 sm:px-5 py-2 rounded-full hover:bg-blue-700"
            onClick={async () => {
              if (isSending) return;
              setIsSending(true);
              await handleAddComment();
              setIsSending(false);
            }}
            disabled={isSending}
          >
            {isSending ? "Sending..." : "Send"}{" "}
          </button>
        </div>
      </div>

      {/* Comments */}
      <div className="flex-1 overflow-y-auto px-3 sm:px-4 py-3 sm:py-4 space-y-3 sm:space-y-4 bg-white">
        {comments.length === 0 ? (
          <p className="text-center text-gray-500 italic">No comments yet.</p>
        ) : (
          comments.map((c) => {
            const isSupplierComment = !!c.supplier_id;
            const displayName = isSupplierComment
              ? "Anonymous"
              : `${c.User?.first_name || ""} ${
                  c.User?.last_name || ""
                }`.trim() || "Customer";

            return (
              <div key={c.id} className="flex items-start gap-2 sm:gap-3">
                {/* Avatar */}
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-400 text-white flex items-center justify-center font-medium flex-shrink-0">
                  {displayName?.[0]?.toUpperCase() || "A"}
                </div>

                {/* Bubble + replies */}
                <div className="flex-1">
                  {/* Comment bubble */}
                  <div className="bg-gray-100 rounded-xl px-3 sm:px-4 py-2">
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-800 text-sm sm:text-base">
                        {displayName}
                      </span>

                      {Number(c.User?.id) === Number(currentSupplierId) && (
                        <div className="flex gap-2 text-gray-400">
                          <IoPencil
                            className="w-4 h-4 cursor-pointer hover:text-blue-600"
                            onClick={() => openEdit(c.id, c.comment)}
                          />
                          <IoTrashBin
                            className="w-4 h-4 cursor-pointer hover:text-red-600"
                            onClick={() => setDeleteTarget(c.id)}
                          />
                        </div>
                      )}
                    </div>

                    {/* body / edit */}
                    {editingId === c.id ? (
                      <div className="mt-1 flex flex-col sm:flex-row sm:gap-2 gap-2">
                        <input
                          className="flex-1 border rounded-md px-2 py-1 text-sm focus:ring-2 focus:ring-green-500"
                          value={editingText}
                          onChange={(e) => setEditingText(e.target.value)}
                        />
                        <div className="flex gap-2 self-end sm:self-auto">
                          <button
                            className="text-green-600 font-medium text-sm"
                            onClick={saveEdit}
                          >
                            Save
                          </button>
                          <button
                            className="text-gray-600 text-sm"
                            onClick={() => setEditingId(null)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p className="mt-1 text-gray-700 text-sm sm:text-base">
                        {c.comment}
                      </p>
                    )}

                    {/* reactions */}
                    <div className="mt-2 flex gap-4 text-sm text-gray-500">
                      <button
                        className="flex items-center gap-1"
                        onClick={() => handleReaction(c.id, "like")}
                      >
                        <IoThumbsUp className="w-4 h-4" />
                        <span>{c.like || 0}</span>
                      </button>
                      <button
                        className="flex items-center gap-1"
                        onClick={() => handleReaction(c.id, "dislike")}
                      >
                        <IoThumbsDown className="w-4 h-4" />
                        <span>{c.dislike || 0}</span>
                      </button>
                    </div>
                  </div>

                  {/* Replies */}
                  <div className="mt-3 pl-6 sm:pl-12 space-y-3">
                    {c.replies.map((r) => {
                      const ru = r.User || r.Customer || r.user || {};
                      const isSupplierReply = r.reply_by_role === "SUPPLIER";
                      const replyName = isSupplierReply
                        ? "Anonymous"
                        : `${ru.first_name || ""} ${
                            ru.last_name || ""
                          }`.trim() ||
                          r.author ||
                          "Customer";

                      return (
                        <div
                          key={r.id}
                          className="flex items-start gap-2 sm:gap-3"
                        >
                          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center font-medium flex-shrink-0">
                            {replyName?.[0]?.toUpperCase() || "C"}
                          </div>

                          <div className="flex-1 bg-gray-100 rounded-xl px-3 py-2">
                            <div className="flex items-center justify-between">
                              <span className="font-medium text-gray-800 text-xs sm:text-sm">
                                {replyName}
                              </span>

                              {isSupplierReply &&
                                Number(
                                  r.supplier_id ??
                                    r.reply_by_supplier_id ??
                                    ru?.id
                                ) === Number(currentSupplierId) && (
                                  <div className="flex gap-2 text-gray-400">
                                    <IoPencil
                                      className="w-4 h-4 cursor-pointer hover:text-blue-600"
                                      onClick={() =>
                                        openEditReply(r.id, r.reply)
                                      }
                                    />
                                    <IoTrashBin
                                      className="w-4 h-4 cursor-pointer hover:text-red-600"
                                      onClick={() => setDeleteReplyId(r.id)}
                                    />
                                  </div>
                                )}
                            </div>

                            {editingReplyId === r.id ? (
                              <div className="mt-1 flex flex-col sm:flex-row sm:gap-2 gap-2">
                                <input
                                  className="flex-1 border rounded-md px-2 py-1 text-xs sm:text-sm focus:ring-2 focus:ring-green-500"
                                  value={editingReplyText}
                                  onChange={(e) =>
                                    setEditingReplyText(e.target.value)
                                  }
                                />
                                <div className="flex gap-2 self-end sm:self-auto">
                                  <button
                                    className="text-green-600 text-xs sm:text-sm font-medium"
                                    onClick={saveEditReply}
                                  >
                                    Save
                                  </button>
                                  <button
                                    className="text-gray-600 text-xs sm:text-sm"
                                    onClick={() => setEditingReplyId(null)}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <p className="mt-1 text-gray-700 text-xs sm:text-sm">
                                {r.reply || r.comment}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    {/* reply input */}
                    <div className="pl-6 sm:pl-12 pt-3 flex flex-col sm:flex-row sm:gap-2 gap-2">
                      <input
                        className="flex-1 border rounded-md px-2 py-1 text-xs sm:text-sm focus:ring-2 focus:ring-blue-500"
                        placeholder="Type your reply..."
                        value={replyDrafts[c.id] || ""}
                        onChange={(e) =>
                          setReplyDrafts((p) => ({
                            ...p,
                            [c.id]: e.target.value,
                          }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !submittingIds[c.id]) {
                            e.preventDefault();
                            handleAddReply(c.id);
                          }
                        }}
                      />
                      <div className="flex gap-2 self-end sm:self-auto">
                        <button
                          className="bg-blue-600 text-white text-xs sm:text-sm px-3 py-1 rounded-md hover:bg-blue-700"
                          onClick={() => handleAddReply(c.id)}
                          disabled={!!submittingIds[c.id]}
                        >
                          Send
                        </button>
                        <button
                          className="text-xs sm:text-sm text-gray-600"
                          onClick={() =>
                            setReplyDrafts((p) => ({ ...p, [c.id]: "" }))
                          }
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* delete comment confirmation */}
      {deleteTarget && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-80">
            <p className="text-center mb-4">Delete this comment?</p>
            <div className="flex justify-center space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setDeleteTarget(null)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* delete reply confirmation */}
      {deleteReplyId && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-80">
            <p className="text-center mb-4">Delete this reply?</p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setDeleteReplyId(null)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                onClick={confirmDeleteReply}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ClarificationBoard;
